/* Dchica Teens by MT — abd.js (no dependencies) */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.abdTheme || { routes: {}, strings: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '₹{{amount}}';
    const delimit = (n, d, t, dec) => {
      const parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delimit(cents, 0, '.', ','); break;
      default: v = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- Drawers / overlay ---------- */
  const overlay = $('[data-abd-overlay]');
  let openEl = null;
  let lastFocus = null;

  function open(id) {
    const el = document.getElementById(id);
    if (!el) return false;
    close();
    lastFocus = document.activeElement;
    el.classList.add('abd-is-open');
    overlay && overlay.classList.add('abd-is-active');
    document.body.classList.add('abd-no-scroll');
    openEl = el;
    const f = el.querySelector('input[type=search], button, a, input');
    setTimeout(() => f && f.focus(), 50);
    return true;
  }
  function close() {
    if (!openEl) return;
    openEl.classList.remove('abd-is-open');
    overlay && overlay.classList.remove('abd-is-active');
    document.body.classList.remove('abd-no-scroll');
    openEl = null;
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-abd-open]');
    if (opener) {
      if (open(opener.dataset.abdOpen)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-abd-close]') || e.target === overlay) close();

    const mOpen = e.target.closest('[data-abd-open-modal]');
    if (mOpen) { const m = document.getElementById(mOpen.dataset.abdOpenModal); m && m.classList.add('abd-is-open'); document.body.classList.add('abd-no-scroll'); }
    if (e.target.closest('[data-abd-close-modal]')) { $$('.abd-modal.abd-is-open').forEach((m) => m.classList.remove('abd-is-open')); document.body.classList.remove('abd-no-scroll'); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); $$('.abd-modal.abd-is-open').forEach((m) => m.classList.remove('abd-is-open')); document.body.classList.remove('abd-no-scroll'); }
  });

  /* ---------- Header scroll ---------- */
  const header = $('[data-abd-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('abd-is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reveal ---------- */
  function initReveal(ctx = document) {
    const els = $$('.abd-reveal:not(.abd-is-in)', ctx);
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('abd-is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en, i) => {
        if (en.isIntersecting) {
          setTimeout(() => en.target.classList.add('abd-is-in'), Math.min(i, 6) * 70);
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    const track = $('[data-abd-hero-track]', root);
    if (!track) return;
    const slides = $$('.abd-hero__slide', track);
    const dots = $$('[data-abd-hero-dot]', root);
    let idx = 0, timer;
    const go = (i) => { idx = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' }); };
    const setActive = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      idx = i;
      slides.forEach((s, n) => s.classList.toggle('abd-is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('abd-is-active', n === i));
    };
    track.addEventListener('scroll', () => { clearTimeout(track._t); track._t = setTimeout(setActive, 60); }, { passive: true });
    dots.forEach((d) => d.addEventListener('click', () => { go(+d.dataset.abdHeroDot); restart(); }));
    const prev = $('[data-abd-hero-prev]', root), next = $('[data-abd-hero-next]', root);
    prev && prev.addEventListener('click', () => { go(idx - 1); restart(); });
    next && next.addEventListener('click', () => { go(idx + 1); restart(); });
    const autoplay = root.dataset.abdAutoplay === 'true' && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = (parseInt(root.dataset.abdSpeed, 10) || 6) * 1000;
    function restart() { clearInterval(timer); if (autoplay) timer = setInterval(() => go(idx + 1), speed); }
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', restart);
    restart();
  }

  /* ---------- Generic sliders ---------- */
  function initSlider(root) {
    if (root._init) return; root._init = true;
    const id = root.dataset.abdSlider;
    const track = $('[data-abd-slider-track]', root);
    if (!track) return;
    const prevs = $$(`[data-abd-slider-prev="${id}"]`);
    const nexts = $$(`[data-abd-slider-next="${id}"]`);
    const bar = $('[data-abd-slider-progress]', root);
    const step = () => { const c = track.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prevs.forEach((b) => (b.disabled = track.scrollLeft <= 2));
      nexts.forEach((b) => (b.disabled = track.scrollLeft >= max - 2));
      if (bar) {
        const ratio = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 10) + '%';
        bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (100 / Math.max(ratio, 0.1) - 100) : 0}%)`;
        bar.parentElement.style.display = ratio >= 0.999 ? 'none' : '';
      }
    };
    prevs.forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
    nexts.forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Tabs ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-abd-tab]');
    if (!tab) return;
    const list = tab.parentElement;
    $$('[data-abd-tab]', list).forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      const panel = document.getElementById(t.dataset.abdTab);
      if (panel) panel.hidden = !on;
    });
    const panel = document.getElementById(tab.dataset.abdTab);
    if (panel) { $$('[data-abd-slider]', panel).forEach(initSlider); initReveal(panel); }
  });

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    const end = new Date(el.dataset.abdCountdown.replace(' ', 'T')).getTime();
    if (isNaN(end)) { el.remove(); return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let d = Math.max(0, end - Date.now()) / 1000;
      $('[data-abd-d]', el).textContent = pad(Math.floor(d / 86400)); d %= 86400;
      $('[data-abd-h]', el).textContent = pad(Math.floor(d / 3600)); d %= 3600;
      $('[data-abd-m]', el).textContent = pad(Math.floor(d / 60));
      $('[data-abd-s]', el).textContent = pad(Math.floor(d % 60));
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Footer accordions ---------- */
  const mq = window.matchMedia('(min-width: 990px)');
  const syncFooter = () => $$('[data-abd-footer-accordion]').forEach((d) => { if (mq.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); });
  mq.addEventListener ? mq.addEventListener('change', syncFooter) : mq.addListener(syncFooter);

  /* ---------- Toast ---------- */
  function toast(msg) {
    let t = $('.abd-toast');
    if (!t) { t = document.createElement('div'); t.className = 'abd-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('abd-is-visible');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('abd-is-visible'), 2600);
  }

  /* ---------- Cart ---------- */
  const cartDrawerEl = () => document.getElementById('AbdCartDrawer');
  const isDrawer = () => T.cartType !== 'page' && !!cartDrawerEl();

  function updateCount(count) {
    $$('[data-abd-cart-count-bubble]').forEach((b) => { b.textContent = count > 0 ? count : ''; b.dataset.abdCount = count; });
  }

  async function refreshCart(openAfter) {
    const current = cartDrawerEl();
    if (!current) return false;
    try {
      const res = await fetch(`${T.routes.root_url.replace(/\/$/, '')}/?sections=abd-cart-drawer`, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('sections ' + res.status);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['abd-cart-drawer'] || '', 'text/html');
      const fresh = html.querySelector('[data-abd-cart-drawer]');
      if (!fresh) throw new Error('no drawer markup');
      current.innerHTML = fresh.innerHTML;
      updateCount(fresh.dataset.abdCartCount);
    } catch (err) {
      // Fallback: at least update the count from cart.js
      try { const c = await (await fetch(T.routes.cart_url + '.js')).json(); updateCount(c.item_count); } catch (e) {}
      if (openAfter) { window.location.href = T.routes.cart_url; return false; }
    }
    if (openAfter) open('AbdCartDrawer');
    return true;
  }

  async function addToCart(formData, btn, opts = {}) {
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = T.strings.adding || 'Adding…'; }
    try {
      const res = await fetch(T.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart');
      if (opts.checkout) { window.location.href = T.routes.checkout_url || '/checkout'; return; }
      if (isDrawer()) await refreshCart(true);
      else window.location.href = T.routes.cart_url;
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn && !opts.checkout) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
    }
  }

  async function changeLine(line, quantity) {
    const wrap = cartDrawerEl();
    wrap && wrap.setAttribute('data-abd-cart-loading', '');
    try {
      const res = await fetch(T.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +line, quantity: Math.max(0, +quantity) })
      });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Error');
      if ($('[data-abd-cart-page]')) { window.location.reload(); return; }
      await refreshCart(false);
    } catch (err) { toast(err.message); }
    finally { wrap && wrap.removeAttribute('data-abd-cart-loading'); }
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-abd-qty-change]');
    if (b && b.dataset.abdLine) { e.preventDefault(); changeLine(b.dataset.abdLine, b.dataset.abdQtyChange); }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-abd-line-input]');
    if (i) changeLine(i.dataset.abdLineInput, i.value);
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-abd-quick-add]');
    if (f) { e.preventDefault(); addToCart(new FormData(f), f.querySelector('button')); }
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    const form = $('[data-abd-product-form]', root);
    const picker = $('[data-abd-variant-picker]', root);
    const variantsEl = picker && $('[data-abd-variants]', picker);
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const idInput = form && $('[data-abd-variant-id]', form);
    const atc = form && $('[data-abd-add-to-cart]', form);
    const buy = form && $('[data-abd-buy-now]', form);
    const gallery = $('[data-abd-gallery]', root);
    const thumbs = $$('[data-abd-thumb]', root);
    const count = $('[data-abd-gallery-count]', root);
    const sticky = $('[data-abd-sticky-atc]');

    // Quantity
    if (form) {
      const q = $('input[name=quantity]', form);
      $('[data-abd-qty-minus]', form).addEventListener('click', () => (q.value = Math.max(1, (+q.value || 1) - 1)));
      $('[data-abd-qty-plus]', form).addEventListener('click', () => (q.value = (+q.value || 1) + 1));
      form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(new FormData(form), atc); });
      const buyNow = $('[data-abd-buy-now]', form);
      buyNow && buyNow.addEventListener('click', () => addToCart(new FormData(form), buyNow, { checkout: true }));
    }

    // Gallery carousel
    let current = 0;
    if (gallery) {
      const slides = $$('.abd-gallery__slide', gallery);
      const prevBtn = $('[data-abd-gallery-prev]', root), nextBtn = $('[data-abd-gallery-next]', root);
      const isGrid = () => getComputedStyle(gallery).display === 'grid';
      const goTo = (i) => {
        if (isGrid()) return;
        current = Math.max(0, Math.min(i, slides.length - 1));
        gallery.scrollTo({ left: slides[current].offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        mark();
      };
      const mark = () => {
        thumbs.forEach((t, n) => t.classList.toggle('abd-is-active', n === current));
        const at = thumbs[current]; if (at) { const tw = at.parentElement; tw.scrollTo({ left: at.offsetLeft - tw.offsetLeft - tw.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' }); }
        if (count) count.textContent = `${current + 1} / ${slides.length}`;
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === slides.length - 1;
      };
      const sync = () => {
        const i = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
        if (i !== current) { current = Math.max(0, Math.min(i, slides.length - 1)); mark(); }
      };
      gallery.addEventListener('scroll', () => { clearTimeout(gallery._t); gallery._t = setTimeout(sync, 60); }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(+t.dataset.abdThumb)));
      prevBtn && prevBtn.addEventListener('click', () => goTo(current - 1));
      nextBtn && nextBtn.addEventListener('click', () => goTo(current + 1));
      gallery.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') goTo(current + 1); if (e.key === 'ArrowLeft') goTo(current - 1); });
      mark();
      root._showMedia = (mediaId) => {
        const target = slides.findIndex((sl) => sl.dataset.abdMediaId == mediaId);
        if (target < 0) return;
        if (isGrid()) { if (target > 0) gallery.prepend(slides[target]); }
        else goTo(target);
      };

      // Zoom lightbox
      const lb = $('[data-abd-lightbox]', root.parentElement) || $('[data-abd-lightbox]');
      const lbData = lb && $('[data-abd-lightbox-data]', lb);
      const images = lbData ? JSON.parse(lbData.textContent) : [];
      if (lb && images.length) {
        const img = $('[data-abd-lightbox-img]', lb);
        const vp = $('[data-abd-lightbox-viewport]', lb);
        const counter = $('[data-abd-lightbox-count]', lb);
        let pos = 0, zoomed = false, ox = 50, oy = 50, lastFocus = null;
        const SCALE = 2.5;
        const apply = () => {
          img.style.transformOrigin = `${ox}% ${oy}%`;
          img.style.transform = zoomed ? `scale(${SCALE})` : 'none';
          lb.classList.toggle('abd-is-zoomed', zoomed);
        };
        const show = (p) => {
          pos = (p + images.length) % images.length;
          zoomed = false; ox = oy = 50; apply();
          img.src = images[pos].src; img.alt = images[pos].alt || '';
          counter.textContent = images.length > 1 ? `${pos + 1} / ${images.length}` : '';
        };
        const openAt = (mediaIndex) => {
          let p = images.findIndex((im) => im.index === mediaIndex);
          if (p < 0) p = Math.max(0, images.findIndex((im) => im.index > mediaIndex));
          lastFocus = document.activeElement;
          lb.hidden = false; document.body.classList.add('abd-no-scroll');
          show(p);
          setTimeout(() => $('[data-abd-lightbox-close]', lb).focus(), 30);
        };
        const closeLb = () => { lb.hidden = true; document.body.classList.remove('abd-no-scroll'); zoomed = false; apply(); lastFocus && lastFocus.focus && lastFocus.focus(); };
        const originFrom = (x, y) => {
          const r = img.getBoundingClientRect();
          // when zoomed, rect is scaled; map back to the unscaled box
          ox = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
          oy = Math.max(0, Math.min(100, ((y - r.top) / r.height) * 100));
        };

        slides.forEach((sl, i) => { if (sl.classList.contains('abd-gallery__slide--image')) sl.addEventListener('click', () => openAt(i)); });
        const zoomBtn = $('[data-abd-zoom-current]', root);
        zoomBtn && zoomBtn.addEventListener('click', (e) => { e.stopPropagation(); openAt(current); });
        $('[data-abd-lightbox-close]', lb).addEventListener('click', closeLb);
        const lp = $('[data-abd-lightbox-prev]', lb), ln = $('[data-abd-lightbox-next]', lb);
        lp && lp.addEventListener('click', () => show(pos - 1));
        ln && ln.addEventListener('click', () => show(pos + 1));
        document.addEventListener('keydown', (e) => {
          if (lb.hidden) return;
          if (e.key === 'Escape') { e.stopPropagation(); closeLb(); }
          if (e.key === 'ArrowRight' && !zoomed) show(pos + 1);
          if (e.key === 'ArrowLeft' && !zoomed) show(pos - 1);
        });

        // Mouse: click to zoom, move to pan
        let moved = false, touch = null;
        vp.addEventListener('click', (e) => {
          if (moved) { moved = false; return; }
          if (e.target !== img) { if (!zoomed) return; }
          if (!zoomed) { originFrom(e.clientX, e.clientY); zoomed = true; } else zoomed = false;
          apply();
        });
        vp.addEventListener('mousemove', (e) => {
          if (!zoomed || e.pointerType === 'touch') return;
          const r = vp.getBoundingClientRect();
          ox = ((e.clientX - r.left) / r.width) * 100; oy = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = `${ox}% ${oy}%`;
        });
        // Touch: swipe to change image, drag to pan when zoomed
        vp.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) return;
          touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, ox, oy, t: Date.now() };
          moved = false;
        }, { passive: true });
        vp.addEventListener('touchmove', (e) => {
          if (!touch || e.touches.length !== 1) return;
          const dx = e.touches[0].clientX - touch.x, dy = e.touches[0].clientY - touch.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
          if (zoomed) {
            e.preventDefault();
            const r = vp.getBoundingClientRect();
            ox = Math.max(0, Math.min(100, touch.ox - (dx / r.width) * 100 * 1.2));
            oy = Math.max(0, Math.min(100, touch.oy - (dy / r.height) * 100 * 1.2));
            img.style.transformOrigin = `${ox}% ${oy}%`;
          }
        }, { passive: false });
        vp.addEventListener('touchend', (e) => {
          if (!touch) return;
          const dx = e.changedTouches[0].clientX - touch.x, dy = e.changedTouches[0].clientY - touch.y;
          if (!zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { show(pos + (dx < 0 ? 1 : -1)); moved = true; }
          touch = null;
          if (moved) setTimeout(() => (moved = false), 350);
        });
      }
    }

    // Variants
    if (picker && variants.length) {
      const onChange = () => {
        const selected = [];
        $$('fieldset', picker).forEach((fs, i) => {
          const c = $('input:checked', fs);
          selected[i] = c ? c.value : null;
          const lbl = $(`[data-abd-option-label="${i}"]`, picker);
          if (lbl && c) lbl.textContent = c.value;
        });
        const v = variants.find((v) => v.options.every((o, i) => o === selected[i]));
        // availability hints for other options
        $$('input[data-abd-option-index]', picker).forEach((inp) => {
          const oi = +inp.dataset.abdOptionIndex;
          const ok = variants.some((v) => v.available && v.options[oi] === inp.value && v.options.every((o, i) => i === oi || i > oi || o === selected[i]));
          inp.classList.toggle('abd-is-unavailable', !ok);
        });
        updateVariant(v);
      };
      picker.addEventListener('change', onChange);
    }

    function updateVariant(v) {
      if (!atc) return;
      if (!v) {
        atc.disabled = true; atc.textContent = T.strings.unavailable;
        if (buy) buy.disabled = true;
        if (sticky) $('[data-abd-sticky-btn]', sticky).disabled = true;
        return;
      }
      idInput.value = v.id;
      atc.disabled = !v.available;
      if (buy) buy.disabled = !v.available;
      atc.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      const priceWrap = $('[data-abd-price-wrap] [data-abd-price]', root);
      if (priceWrap) {
        let html = `<span class="abd-price__current">${formatMoney(v.price)}</span>`;
        if (v.compare_at_price > v.price) {
          const off = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
          html += `<s class="abd-price__compare">${formatMoney(v.compare_at_price)}</s><span class="abd-price__off">${off}% off</span>`;
        }
        priceWrap.innerHTML = html;
      }
      if (sticky) {
        $('[data-abd-sticky-price]', sticky).textContent = formatMoney(v.price);
        $('[data-abd-sticky-btn]', sticky).disabled = !v.available;
      }
      if (v.featured_media && root._showMedia) root._showMedia(v.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Sticky ATC
    if (sticky && form) {
      $('[data-abd-sticky-btn]', sticky).addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('abd-is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
      io.observe(form);
    }
  }

  /* ---------- Collection filters & sort ---------- */
  function initFacets() {
    $$('[data-abd-facet-form]').forEach((f) => {
      let t;
      f.addEventListener('change', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const params = new URLSearchParams(new FormData(f));
          for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
          window.location.search = params.toString();
        }, 350);
      });
    });
    const sort = $('[data-abd-sort]');
    sort && sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    const input = $('[data-abd-predictive-input]');
    const out = $('[data-abd-predictive-results]');
    const suggest = $('[data-abd-search-suggest]');
    if (!input || !out) return;
    let t, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; suggest && (suggest.style.display = ''); return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const res = await fetch(`${T.routes.predictive_search_url}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, { signal: ctrl.signal });
          const data = await res.json();
          const items = (data.resources && data.resources.results.products) || [];
          suggest && (suggest.style.display = 'none');
          out.innerHTML = items.length
            ? items.map((p) => `<a href="${p.url}">${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=120" alt="" loading="lazy">` : ''}<div><strong style="color:var(--abd-c-ink);font-weight:500">${p.title}</strong><div class="abd-price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</div></div></a>`).join('') +
              `<a href="${T.routes.root_url.replace(/\/$/, '')}/search?q=${encodeURIComponent(q)}" class="abd-link-arrow" style="display:inline-flex;margin-top:8px">View all results →</a>`
            : `<p style="color:var(--abd-c-muted)">No products found for “${q.replace(/</g, '&lt;')}”.</p>`;
        } catch (e) { /* aborted */ }
      }, 220);
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-abd-recommendations]').forEach(async (el) => {
      if (el.children.length && el.querySelector('.abd-card')) return;
      try {
        const res = await fetch(el.dataset.abdUrl);
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const inner = html.querySelector('[data-abd-recommendations]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; $$('[data-abd-slider]', el).forEach(initSlider); }
      } catch (e) {}
    });
  }

  /* ---------- Login recover toggle ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-abd-toggle-recover]')) { const r = document.getElementById('recover'); r && r.scrollIntoView({ behavior: 'smooth' }); }
  });

  /* ---------- Video (abd) — click to play YouTube / Vimeo ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-abd-video-play]');
    if (!btn) return;
    const wrap = btn.closest('abd-video');
    const id = wrap && wrap.dataset.abdId;
    const src = wrap.dataset.abdSource === 'vimeo'
      ? `https://player.vimeo.com/video/${id}?autoplay=1&playsinline=1`
      : `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0&modestbranding=1`;
    const f = document.createElement('iframe');
    f.className = 'abd-video__media';
    f.src = src; f.title = 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
    btn.replaceWith(f);
  });

  /* ---------- Init ---------- */
  // Drawers rendered inside sections (menu) are moved to <body> so the sticky header never traps them
  function hoistDrawers(ctx = document) {
    $$('.abd-drawer', ctx).forEach((d) => {
      if (d.parentElement === document.body) return;
      if (d.id) Array.from(document.body.children).forEach((c) => { if (c.id === d.id && c !== d) c.remove(); });
      if (d.id === 'AbdCartDrawer' || d.id === 'AbdFilterDrawer') return;
      document.body.appendChild(d);
    });
  }

  function init(ctx = document) {
    hoistDrawers(ctx);
    $$('[data-abd-hero]', ctx).forEach(initHero);
    $$('[data-abd-slider]', ctx).forEach((s) => { if (!s.closest('[hidden]')) initSlider(s); });
    $$('[data-abd-countdown]', ctx).forEach(initCountdown);
    $$('[data-abd-product]', ctx).forEach(initProduct);
    initReveal(ctx);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    // Fail-safe: never leave content hidden if an observer doesn't fire
    setTimeout(() => $$('.abd-reveal:not(.abd-is-in)').forEach((el) => el.classList.add('abd-is-in')), 2500);
    syncFooter();
    initFacets();
    initSearch();
    initRecommendations();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.abd-hero__slide');
    if (slide) { const track = slide.parentElement; track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); }
  });
})();
